import { render } from "./MainActivity.vue?vue&type=template&id=360c2501&scoped=true"
import script from "./MainActivity.vue?vue&type=script&lang=js"
export * from "./MainActivity.vue?vue&type=script&lang=js"

import "./MainActivity.vue?vue&type=style&index=0&id=360c2501&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360c2501"]])

export default __exports__